import Slider from '../../../components/slider/Slider'
import styles from './SecondaryText.module.css'
import { Col, Row } from 'react-bootstrap'

export default function SecondaryText() {
    const path = "./assets/images/"
    const images = [ "car-1.jpg", "car-2.jpg"/*, "car-3.jpg"*/ ].map(x => `${path}${x}`)

    return (
        <section>
            <Row className='m-auto align-items-start justify-content-center justify-content-lg-between mt-5 mb-5'>
                <Col lg="1" className='d-none d-lg-block'></Col>
                
                <Col xs="11" sm="11" md="12" lg="4" className='order-2 order-md-1 mt-5 mt-md-0'>
                    <h2 className={ `${styles.title} mb-5` }>MONO racing,<br />a new era begins</h2>

                    <p className={styles.text}>We are thrilled to announce MONO’s entry into the European Le Mans Series with LMP3, in partnership with M Racing. Led by the legendary Ivan Muller and dynamic team leader Justine Monnier, M Racing brings championship expertise to the track. Drivers Quentin Antonel and Stéphane Tribaudini will represent MONO in this high-stakes competition.</p>

                    <p className={styles.text}>A new chapter begins—fast, fearless, and ready for victory.</p>
                </Col>

                <Col xs="12" sm="12" md="12" lg="6" className='order-1 order-md-2 p-0'>
                    <Slider
                        images={ images }
                        reverse={ true }
                        buttonContainerClassName={styles.sliderButtonContainer}
                        autoplay
                        autoplayDuration={ 4000 }
                    />
                </Col>
            </Row>
        </section>
    )
}